import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { SupportedLanguageCode } from '@config';
import { environment } from '@env/environment';
import { TranslocoService } from '@jsverse/transloco';
import { Store } from '@ngrx/store';
import { ToastModule } from 'primeng/toast';
import { filter } from 'rxjs';
import { LanguageInitializationService } from './_shared/service/language-initialization.service';
import { PrimeNGTranslationService } from './_shared/service/primeng-translation.service';
import { STALE_CHUNK_ERROR__RELOAD_REQUESTED } from './global-error-handler';
import { MainState } from './main-store/main-state';

@Component({
  selector: 'sb-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, ToastModule],
})
export class AppComponent implements OnInit {
  store = inject<Store<MainState>>(Store);
  private _window = inject(Window);
  private translocoService = inject(TranslocoService);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);

  // Inject PrimeNGTranslationService to ensure it gets instantiated and starts listening for language changes
  private _primeNGTranslationService = inject(PrimeNGTranslationService);

  constructor() {
    this.clearStaleChunkFlagOnNavigation();
  }

  async ngOnInit() {
    this.initiateStripe();
    await this.initializePrimeNGTranslations();
  }

  private async initializePrimeNGTranslations() {
    try {
      const currentLanguage = LanguageInitializationService.initializeLanguage();
      await this.translocoService.setActiveLang(currentLanguage as SupportedLanguageCode);
    } catch (error) {
      console.warn('Failed to initialize PrimeNG translations:', error);
    }
  }

  initiateStripe() {
    (this._window as any).stripe = window.Stripe(environment.stripePubKey);
    (this._window as any).elements = window.stripe.elements();
  }

  private clearStaleChunkFlagOnNavigation(): void {
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        sessionStorage.removeItem(STALE_CHUNK_ERROR__RELOAD_REQUESTED);
      });
  }
}
